import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5a27a68f")

_pushScopeId("data-v-5a27a68f")
const _hoisted_1 = { class: "chat-area" }
const _hoisted_2 = {
  key: 0,
  class: "header"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "panel" }, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "empty-wrap"
}
const _hoisted_6 = { class: "background-text" }
const _hoisted_7 = {
  key: 2,
  class: "messages-wrap"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Message = _resolveComponent("Message")
  const _component_TextArea = _resolveComponent("TextArea")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isMobileScreen)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_Button, {
            class: "back-btn",
            icon: { spriteUrl: '/image/videoconf-icons.svg', name: 'ic25-shape'},
            size: "s",
            mode: "flat",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openDrawer('settings')))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t('back')), 1)
            ]),
            _: 1
          }, 8, ["icon"]),
          _createVNode("h2", _hoisted_3, _toDisplayString(_ctx.t('menuList.chat')), 1)
        ]))
      : _createCommentVNode("", true),
    _hoisted_4,
    (!_ctx.chatList.length)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode("img", {
            class: "background-image",
            src: require('../../assets/images/no-messages-files-background.png')
          }, null, 8, ["src"]),
          _createVNode("p", _hoisted_6, _toDisplayString(_ctx.t('chat.noMessage')), 1)
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_7, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.chatList, (item) => {
            return (_openBlock(), _createBlock(_component_Message, {
              name: item.name,
              time: item.time,
              avatar: item.avatar,
              message: item.message,
              isPrivate: false
            }, null, 8, ["name", "time", "avatar", "message"]))
          }), 256))
        ])),
    _createVNode(_component_TextArea)
  ]))
})